<template>
  <div id="c4">
    <ReportDraftWatermark v-if="report.is_draft"/>
    <div class="report-section">
      <v-simple-table dense>
        <tbody>
        <tr>
          <td>
            <span v-if="report.filer_name">{{ report.filer_name }}<br/></span>
            <span v-if="compareAndDisplayName">{{ committee.name }} - </span>
            <span class="registrationLink">(<a :href="report.committee_data.url" target="_blank">Registration</a>)<br/></span>
            {{ committee.address }}<br/>
            {{ committee.city }}, {{ committee.state }}
            {{ committee.postcode }}<br/>
            <span v-if="report.office">{{ report.office }}<br/>{{ report.jurisdiction }}</span>
          </td>
          <td>
            <div>Coverage: {{ formatDate(report.user_data.period_start) }} to {{
                formatDate(report.user_data.period_end)
              }}
            </div>
            <div>Report number: {{ report.report_number }} <span
                v-if="report.amended_by_report">Amended by {{ report.amended_by_report }}</span><span
                v-if="report.amends_report">Amends {{ report.amends_report }}</span></div>
            <div>
              {{ electionYearDetails() }}
            </div>
            <div>Date submitted: <span v-if="report.report_number">{{
                formatDate(report.user_data.submitted_at)
              }}</span></div>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div class="report-section">
      <h3 class="line-item-title">Receipts</h3>
      <v-simple-table dense>
        <tbody>
        <tr>
          <td>
            1. Previous total cash and in-kind contributions (last C4 line 8).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.previous_receipts.amount) }}
          </td>
        </tr>
        <tr>
          <td>
            2. Cash received (Schedule A line 1).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.cash_receipts.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            3. In-kind contributions received (Line 1 schedule B).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.inkind_receipts.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            4. Total cash and in-kind contributions received this period (Lines 2 + 3).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.total_receipts.amount) }}
          </td>
        </tr>
        <tr>
          <td>
            5. Loan principal repayments made (Line 2 schedule L).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.loan_principle_paid.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            6. Corrections (Lines 1 or 3 schedule C).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.receipt_corrections.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            7. Net adjustments this period (Lines 5 + 6).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.receipt_adjustments.amount) }}
          </td>
        </tr>
        <tr>
          <td>
            8. Total cash and in-kind contributions during campaign (Lines 1 + 4 + 7).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.campaign_receipts.amount) }}
          </td>
        </tr>
        <tr>
          <td>
            9. Total pledge payments due (Line 2 schedule B).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.receipts.pledges.amount) }}
          </td>
          <td></td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div class="report-section">
      <h3 class="line-item-title">Expenditures</h3>
      <v-simple-table dense>
        <tbody>
        <tr>
          <td>
            10. Previous total cash and in-kind expenditures (Last C-4 line 17).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.previous_expenditures.amount) }}
          </td>
        </tr>
        <tr>
          <td>
            11. Cash expenditures (Line 3 schedule A).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.cash_expenditures.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            12. In-kind expenditures (Line 1 schedule B).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.inkind_expenditures.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            13. Total cash and in-kind expenditures made this period (Lines 11 + 12).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.total_expenditures.amount) }}
          </td>
        </tr>
        <tr>
          <td>
            14. Loan principal repayment made (Line 2 schedule L).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.loan_principle_paid.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            15. Corrections (Lines 2 + 3 schedule C).
          </td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.expense_corrections.amount) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            16. Net adjustments this period (Lines 14 + 15).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.expense_adjustments.amount) }}
          </td>
        </tr>
        <tr>
          <td>
            17. Total cash and in-kind expenditures during campaign (Lines 10 + 13 + 16).
          </td>
          <td></td>
          <td class="amountColumn">
            {{ formatMoney(report.metadata.sums.expenditures.campaign_expenses.amount) }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div class="report-section">
      <h3 class="line-item-title">Cash summary</h3>
      <v-simple-table dense>
        <tbody>
        <tr>
          <td>18. Cash on hand (Lines 8 - 17)<br/>
            Line 18 should equal your reconciled bank account balance(s) plus your petty cash balance.
          </td>
          <td class="amountColumn">{{ formatMoney(report.metadata.sums.cash_summary.cash_on_hand.amount) }}</td>
        </tr>
        <tr>
          <td>19. Liabilities: (Sum of loans and debts owed)</td>
          <td class="amountColumn">{{ formatMoney(report.metadata.sums.cash_summary.liabilities.amount) }}</td>
        </tr>
        <tr>
          <td>20. Balance (Lines 18 - 19)</td>
          <td class="amountColumn">{{ formatMoney(report.metadata.sums.cash_summary.balance.amount) }}</td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div class="report-section">
      <v-divider></v-divider>
      <v-simple-table v-if="!report.is_draft" dense>
        <tbody>
        <tr>
          <td v-if="committee.candidacy_id">
            <div class="small-text">Candidate name</div>
            <div>{{ report.filer_name }}</div>
          </td>
          <td>
            <div class="small-text"><strong>I certify this report is true and complete to the best of my
              knowledge</strong></div>
            <div class="small-text">Treasurer's name and date</div>
            <div>{{ report.user_data.treasurer.name }} - {{ formatDate(report.receipt_date) }}</div>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import filters from "../filters";
import ReportDraftWatermark from "@/components/ReportDraftWatermark.vue";

export default {
  name: "C4Cover",
  props: {
    report: Object
  },
  components: { ReportDraftWatermark },
  methods: {
    ...filters.filters,
    electionYearDetails() {
      return (this.report.committee_data.continuing ? 'Reporting year: ' : 'Election year: ') + this.report.user_data.election_year;
    }
  },
  computed: {
    committee() {
      return this.report.user_data.committee;
    },
    compareAndDisplayName() {
      if (!this.report.filer_name || !this.report.user_data.committee.name) return false;
      return this.report.filer_name.trim() !== this.report.user_data.committee.name.trim();
    },
  }
}
</script>

<style scoped>#c4 { position: relative; }</style>